import type { FC, ReactNode } from 'react'
import type { SxProps, Theme } from '@mui/material'
import { Box, CircularProgress, Typography } from '@mui/material'
import { useAuth } from 'react-oidc-context'

interface AuthLoadingBoundaryProps {
  readonly children: ReactNode
  readonly fallback?: ReactNode
}

export const AuthLoadingBoundary: FC<AuthLoadingBoundaryProps> = ({ children, fallback }) => {
  const { isLoading } = useAuth()

  if (isLoading) {
    return fallback ?? <DefaultLoadingFallback />
  }

  return <>{children}</>
}

const DefaultLoadingFallback: FC = () => (
  <Box sx={loadingContainerSx}>
    <CircularProgress size={24} />
    <Typography variant="body2" sx={loadingTextSx}>
      Checking authentication...
    </Typography>
  </Box>
)

const loadingContainerSx: SxProps<Theme> = {
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 2,
  py: 4,
}

const loadingTextSx: SxProps<Theme> = {
  color: 'text.secondary',
}
